// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"1aad9a2b","782":"96124764"}[chunkId] + ".chunk.css";
};